import React, { useEffect, useState } from "react"
import SearchLocation from "../../ReusableComponents/SearchLocation";
import { getLocations, addLocation } from "../../apis/locations";
import './MultiStepForm.css';
import Loading from "../../ReusableFunctions/Loader";

const AddLocation = React.forwardRef(({ onNext }, ref) => {
  const [locationName, setLocationName] = useState({
    name: "",
    address: ""
  });
  const [center, setCenter] = useState({ lat: undefined, lng: undefined });
  const [initialData, setInitialData] = useState(null);
  const [validationErrors, setvalidationErrors] = useState({
    name:""
  })
  const [hasExistingLocation, setHasExistingLocation] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  const onChangePlace = (e) => {
    setLocationName(prev => ({ ...prev, name: "", address: e.target.value }));
    e.stopPropagation();
  };

  const getExistingLocations = async () => {
    Loading.set(true);
    try {
      const locations = await getLocations();
      if (locations && locations.length > 0) {
        const firstLocation = locations[0];
        setLocationName({
          name: firstLocation.name,
          address: firstLocation.address
        });
        setCenter({
          lat: firstLocation.lat,
          lng: firstLocation.lng
        });
        setInitialData({
          name: firstLocation.name,
          address: firstLocation.address,
          lat: firstLocation.lat,
          lng: firstLocation.lng
        });
        setHasExistingLocation(true);
      } else {
        // No existing locations, use defaults
        setInitialData({
          name: "",
          address: "",
          lat: "",
          lng: ""
        });
        setHasExistingLocation(false);
      }
    } catch (err) {
      console.error("Error fetching locations:", err);
      setInitialData({
        name: "",
        address: "",
        lat: "",
        lng: ""
      });
      setHasExistingLocation(false);
    } finally {
      Loading.set(false);
    }
  };

  React.useImperativeHandle(ref, () => ({
    submitForm: async () => {
      if (!isFormValid) {
        return;
      }

      const currentLocation = {
        name: locationName.name,
        address: locationName.address,
        lat: center.lat,
        lng: center.lng,
        is_active: true
      };

      const hasChanged = initialData 
        ? (currentLocation.name !== initialData.name ||
           currentLocation.address !== initialData.address ||
           currentLocation.lat !== initialData.lat ||
           currentLocation.lng !== initialData.lng)
        : true;

       console.log("haschnaged ",hasChanged)
     
        onNext(hasChanged ? currentLocation : null);
    }
  }));

  useEffect(() => {
    const isValid = (
      locationName.name.trim() !== "" && 
      locationName.address.trim() !== "" && 
      center.lat !== null && 
      center.lng !== null
    );
    if (!isValid) {
      setvalidationErrors({
        name:"Please select the location to proceed"
      })
    }else{
      setvalidationErrors({
        name:""
      })
    }
    setIsFormValid(isValid);
  }, [locationName]);


  useEffect(() => {
    getExistingLocations();
  }, []);

  return (
    <div className="flex flex-col gap-2 h-[100%]"> 
    <div >
      <span
        className="form-title"
      >
        Add Location
      </span>
    </div>
      <div className="flex flex-col gap-2 mb-5">
        <p className="text-[20px] text-[#1E1E1E] font-[700] font-manrope">
          Which location would you like to begin your service in?
        </p>
        <p className="text-[14px] font-manrope text-[#3B3B3B] font-[500]">
          The default service radius is 100 km for this location. You can change it anytime in the Location section. You can add multiple locations.
        </p>
      </div>
      <div className="">
        <SearchLocation
          style={{
            position: "initial",
            width: '85%'
          }}
          value={locationName.address}
          defaultValue={locationName.address}
          placeHolder="Enter the service location"
          onChangePlace={onChangePlace}
          onPlaceSelected={(place) => {
            try {
              const lat = place.geometry.location.lat();
              const lng = place.geometry.location.lng();
              const cntr = {
                lat: parseFloat(lat),
                lng: parseFloat(lng)
              };
              setCenter(cntr);
              setLocationName({ 
                name: place.address_components.find(loc => loc.types[0] === "locality")?.long_name || place.formatted_address.split(",")[0], 
                address: place.formatted_address 
              });
            } catch (e) {
              console.error("Error processing place selection:", e);
            }
          }}
        />
        {validationErrors.name && <p  className="mt-[8px] text-[14px] text-red-500  ">{validationErrors.name}</p>}
      </div>
    </div>
  );
});

export default AddLocation;